"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const login2FASelector_1 = require("../selectors/login2FASelector");
const types_1 = require("../types");
const login2FAAction_1 = require("../actions/login2FAAction");
const react_intl_1 = require("react-intl");
const constants_1 = require("../constants");
const Login2FAOTPStyle_1 = __importDefault(require("./styles/Login2FAOTPStyle"));
const material_1 = require("@mui/material");
const OTP = ({ intl }) => {
    const classes2 = (0, Login2FAOTPStyle_1.default)();
    const dispatch = (0, react_redux_1.useDispatch)();
    const { layoutStatus, maskedMobileNo, otpCode } = (0, react_redux_1.useSelector)(login2FASelector_1.login2FASelector);
    const [otpError, setOtpError] = (0, react_1.useState)({});
    const handleToggleCloseOTP = () => {
        console.log('handleToggleCloseOTP');
        dispatch((0, login2FAAction_1.toggleCloseOtp)());
    };
    const handleOtpInputChange = (event) => {
        const value = event.target.value;
        if (value && value.length > 6) {
            return;
        }
        dispatch((0, login2FAAction_1.setOtpCode)(value));
    };
    const handleToggleSubmitOTP = () => {
        console.log('handleToggleSubmitOTP');
        if (otpCode && otpCode.length === 6) {
            setOtpError({});
            dispatch((0, login2FAAction_1.toggleSubmitOtp)());
        }
        else {
            setOtpError(constants_1.SYSTEM_MESSAGES_LOGIN2FA.OTP_ERROR_EMPTY_OTP);
        }
    };
    const handleToggleLostOrChanged = () => {
        console.log('handleToggleLostOrChanged');
        dispatch((0, login2FAAction_1.toggleLostOrChanged)());
    };
    return (react_1.default.createElement(material_1.Dialog, { open: layoutStatus === types_1.LayoutStatus.OTP, classes: { paper: classes2.dialog }, TransitionComponent: material_1.Slide },
        react_1.default.createElement("div", { className: classes2.DialogContentOuter },
            react_1.default.createElement("div", { style: {
                    display: 'flex',
                    alignItems: 'center',
                    flexWrap: 'wrap'
                } },
                react_1.default.createElement(material_1.Typography, { className: classes2.OTPTitle, variant: "h3" },
                    react_1.default.createElement(react_intl_1.FormattedMessage, { id: "login-2fa-otp-title" })),
                react_1.default.createElement(material_1.Link, { className: classes2.IconClose, onClick: handleToggleCloseOTP })),
            react_1.default.createElement(material_1.DialogContent, null,
                react_1.default.createElement(material_1.ListItem, { className: classes2.ListItem },
                    react_1.default.createElement(material_1.ListItemText, { className: classes2.ListItemText },
                        react_1.default.createElement("div", { className: classes2.StepTips },
                            react_1.default.createElement("div", { className: classes2.FieldGroup },
                                react_1.default.createElement(material_1.Typography, { className: classes2.StepTitle },
                                    react_1.default.createElement(react_intl_1.FormattedMessage, { id: "login-2fa-otp-step-1" })),
                                react_1.default.createElement("div", { className: classes2.StepOTP },
                                    react_1.default.createElement("div", { className: classes2.StepContent },
                                        react_1.default.createElement("div", { className: classes2.StepTxt },
                                            react_1.default.createElement(material_1.Typography, { className: classes2.typography },
                                                react_1.default.createElement(react_intl_1.FormattedMessage, { id: "login-2fa-otp-step-1-detail-1", values: {
                                                        maskedMobileNo: react_1.default.createElement("strong", null, maskedMobileNo)
                                                    } }),
                                                react_1.default.createElement(react_intl_1.FormattedMessage, { id: "login-2fa-otp-step-1-detail-2", values: {
                                                        menuOnTheRight: react_1.default.createElement("strong", null, intl.formatMessage({ id: 'login-2fa-otp-step-1-detail-2-placeholder1' }))
                                                    } }))))))),
                        react_1.default.createElement("div", { className: classes2.StepTips },
                            react_1.default.createElement("div", { className: classes2.FieldGroup },
                                react_1.default.createElement(material_1.Typography, { className: classes2.StepTitle },
                                    react_1.default.createElement(react_intl_1.FormattedMessage, { id: "login-2fa-otp-step-2" })),
                                react_1.default.createElement("div", { className: classes2.StepOTP },
                                    react_1.default.createElement("div", { className: classes2.StepContent },
                                        react_1.default.createElement("div", { className: classes2.StepTxt },
                                            react_1.default.createElement(material_1.Typography, { className: classes2.typography },
                                                react_1.default.createElement(react_intl_1.FormattedMessage, { id: "login-2fa-otp-step-2-detail", values: {
                                                        forAccountLogin: react_1.default.createElement("strong", null, intl.formatMessage({ id: 'login-2fa-otp-step-2-detail-placeholder1' }))
                                                    } }))))))),
                        react_1.default.createElement("div", { className: classes2.StepTips },
                            react_1.default.createElement("div", { className: classes2.FieldGroup },
                                react_1.default.createElement(material_1.Typography, { className: classes2.StepTitle },
                                    react_1.default.createElement(react_intl_1.FormattedMessage, { id: "login-2fa-otp-step-3" })),
                                react_1.default.createElement("div", { className: classes2.StepOTP },
                                    react_1.default.createElement("div", { className: classes2.StepContent },
                                        react_1.default.createElement("div", { className: classes2.StepTxt },
                                            react_1.default.createElement(material_1.Typography, { className: classes2.typography },
                                                react_1.default.createElement(react_intl_1.FormattedMessage, { id: "login-2fa-otp-step-3-detail" })),
                                            react_1.default.createElement("div", { className: classes2.InputOTP },
                                                react_1.default.createElement(material_1.Input, { className: classes2.OTP, classes: { input: classes2.InputHeight, focused: classes2.InputFocus }, fullWidth: true, type: "password", name: "OTP", value: otpCode, onChange: handleOtpInputChange, disableUnderline: true }),
                                                otpError && Object.keys(otpError).length > 0 ? (react_1.default.createElement("div", { className: classes2.OtpError },
                                                    react_1.default.createElement(react_intl_1.FormattedMessage, { id: otpError.msgId, defaultMessage: otpError.defaultMsg }))) : null))))))),
                    react_1.default.createElement(material_1.ListItemIcon, { className: classes2.WrapIcon })),
                react_1.default.createElement("div", { className: "SubmitOutline" },
                    react_1.default.createElement(material_1.Button, { className: classes2.Submit, onClick: handleToggleSubmitOTP, disableTouchRipple: true, disableFocusRipple: true },
                        react_1.default.createElement(react_intl_1.FormattedMessage, { id: "login-2fa-otp-step-submit" })),
                    react_1.default.createElement(material_1.Link, { className: classes2.ModifyMobileLink, onClick: handleToggleLostOrChanged },
                        react_1.default.createElement(react_intl_1.FormattedMessage, { id: "login-2fa-otp-step-label-lost-or-changed" })))))));
};
exports.default = (0, react_intl_1.injectIntl)(OTP);
